import { fromJS } from 'immutable';
import { programPaymentTypesFullNamesMap } from '../../enums/programPaymentTypes';

export default fromJS({
    programPaymentTypes: [...Object.entries(programPaymentTypesFullNamesMap)].map(([id, name]) => ({ id: Number(id), name }))
});